<template>
  <div class="page">
    <van-nav-bar title="家长知情书上传" left-arrow @click-left="$router.go(-1)" fixed :placeholder="true" :safe-area-inset-top="true" />
    
    <van-list>
        <div class="item-box" v-if="qydata != null">
          <div class="date">公司名称:{{ qydata.qymc }}</div>
          <div class="date">岗位名称:{{ qydata.gwmc }}</div>
        </div>
        <div class="item-box" v-else>
          <div class="date-red">{{ qymsg}}</div>
        </div>
    </van-list>

    <van-list>
      <div class="item-box-fj">
        <div class="date"  @click="download">模板下载</div>
      </div>
    </van-list>
    
    <van-form @submit="onSubmit" style="height: calc(100vh - 130px)">
      <van-field style="margin-top: 10px" name="uploader" label="附件上传">
        <template #input>
          <van-uploader accept=".pdf,.png,.jgp" :max-size="5 * 1024 * 1024" @oversize="$toast('文件大小不能超过 5M ')" :max-count="1" :after-read="upload" v-model="fileList" />
          <span style="color: red;">请上传pdf,png,jpg文件</span>
        </template>
      </van-field>
   
      <div class="button-box">
        <van-button round type="info" native-type="submit">上传</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import  iApi  from '@/utils/internship'
export default {
  data() {
    return {
      fileList: [],
      qydata:{},
      qymsg:'',
      isty:'',
      form: {}
    }
  },
  computed: {
    
  },
  methods: {
    async init(){
      const res = await iApi.getSxGwxx();
      this.qydata = res.data;
      this.qymsg = res.Msg;
      this.isty = res.isty;
    },
    async download(){
      const params = {
        type: '2'
      }
      const res = await iApi.downloadDgsx(params)
      const href = URL.createObjectURL(res)
      console.log(href)
      const a = document.createElement('a')
      a.download = "知情同意书"
      a.href = href
      a.click()
    },
    /**
     * @description: 文件上传，通过上传组件，直接将file赋值
     * @param {*} e
     * @return {*}
     */
    upload(e) {
      this.form.file = e.file
    },

    /**
     * @description: 表单提交
     * @param {*}
     * @return {*}
     */
    async onSubmit() {
      if(this.qydata != null){
        this.form.qymc = this.qydata.qymc;
        this.form.gwmc = this.qydata.gwmc;
      }
      this.form.isty = this.isty;
      this.form.type = '2';
      const res = await iApi.fjscSave(this.form)
      if (res.errorCode == 'success') {
        this.$toast.success('上传成功')
        
        setTimeout(() => {
          this.$router.go(-1)
        }, 800)
      }else{
        this.$toast.fail(res.errorMessage)
        setTimeout(() => {
          this.$router.go(-1)
        }, 800)
      }
    },
  },
  created() {
    this.init();
  },
}
</script>

<style lang="less" scoped>
.page {
  min-height: 100vh;
  background: #f2f2f4;
  margin-top: -50px;
}

.item-box-fj {
  width: 100%;
  min-height: 30px;
  background: #ffffff;
  border-radius: 8px;
  margin: 10px auto 0;
  padding: 12px 15px;
  .date {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #006aff;
    margin: 5px 0;
  }
}
.item-box {
  width: 100%;
  min-height: 50px;
  background: #ffffff;
  border-radius: 8px;
  margin: 10px auto 0;
  padding: 12px 15px;
  .title-line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title {
      // width: 280px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 18px;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .status {
      margin-left: 10px;
      min-width: 46px;
      height: 20px;
      border: 1px solid #41b29c;
      border-radius: 10px;
      text-align: center;
      line-height: 20px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #41b29c;
    }
  }
  .date {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    margin: 5px 0;
  }

  .date-red {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: red;
    margin: 5px 0;
  }
  .tip-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    p {
      color: #0088f8;
    }
  }
}
.button-box {
  width: 100%;
  height: 70px;
  background: #ffffff;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .van-button {
    width: 345px;
    height: 50px;
    background: #0189f9;
    border-radius: 25px !important;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    line-height: 50px;
  }
}
.map {
  overflow: hidden;
  width: 0px;
  height: 0px;
}
.position {
  margin-top: 10px;
  width: 345px;
  background: #ffffff;
  padding: 15px;
  .title {
    display: flex;
    justify-content: space-between;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 16px;
  }
  .content {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #b2b2b2;
    margin-top: 5px;
    display: flex;
    align-items: center;
    .van-loading {
      position: relative;
      left: 0;
      margin-right: 10px;
    }
  }
}
.textarea {
  .van-field__body {
    margin-top: 50px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/internship/jzzqs_sc.vue